export const useAnchorScroll = (scrollTop: number = 0) => {
  const smoothScrollTo = (element: HTMLDivElement) => {
    window.scrollTo({
      behavior: 'smooth',
      top: element.offsetTop + scrollTop,
    });
  };

  const scrollToRef = (ref: React.RefObject<HTMLDivElement>) => {
    if (ref.current) {
      smoothScrollTo(ref.current);
    }
  };

  return scrollToRef;
};
